import datatables from 'datatables';

export default () => {
    if($('.publications-page').length > 0) {
        let total = $('#documents').attr('data-total');
        let cur = 10;
        let current_fitler = $('#filter').children("option:selected").attr('data-value');

        $('#more').click(function(){
            cur += 10;
            drawtable();

            if(cur >= total) {
                $(this).attr('disabled', true);
            }
        });

        let table = $('#documents').DataTable({
          paging: false,
          "searching": false,
          "autoWidth": false,
          "order": [1, 'asc'],
        });

        $('#filter').change(function(){
            cur = 10;

            current_fitler = $(this).children("option:selected").attr('data-value');

            let tr = '.row';
            if(current_fitler) {
                tr += '.row--' + current_fitler;
            }

            $('#more').attr('disabled', false);
            if($('#documents').find(tr).length <= cur) {
                $('#more').attr('disabled', true);
            }

            resettable();
            drawtable();
        });

        drawtable()
        function drawtable(){
            let tr = '.row';
            if(current_fitler) {
                tr += '.row--' + current_fitler;
            }

            if(current_fitler === 'poster') {
                table.order([[3, 'desc'], [1, 'asc']]).draw();
            } else {
                table.order([1, 'asc']).draw();
            }

            $('#documents').find(tr).each(function(index, item){
                $(item).addClass('active');
                if(index+1 == cur) {
                    return false;
                }
            });
        }

        function resettable(){
            $('#documents').find('tr.active').each(function(){
                $(this).removeClass('active');
            });
        }
    }
};
